import { render, staticRenderFns } from "./TeacherNotice.vue?vue&type=template&id=41d97394&scoped=true&"
import script from "./TeacherNotice.vue?vue&type=script&lang=js&"
export * from "./TeacherNotice.vue?vue&type=script&lang=js&"
import style0 from "./TeacherNotice.vue?vue&type=style&index=0&id=41d97394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d97394",
  null
  
)

export default component.exports